import { useScrollReveal } from '../../../hooks/useScrollReveal';

const columns = [
  {
    number: "01",
    title: "Capture",
    subtitle: "Never miss a lead",
    desc: "AI voice agents, SMS automation, and web chat intercept every inquiry—24/7, no exceptions.",
    icon: "ri-radar-line",
    color: "from-sapphire/20 to-transparent",
  },
  {
    number: "02",
    title: "Qualify",
    subtitle: "Filter and route instantly",
    desc: "Smart intake logic qualifies leads in real-time and routes them to the right action automatically.",
    icon: "ri-filter-3-line",
    color: "from-deep-sapphire/20 to-transparent",
  },
  {
    number: "03",
    title: "Convert",
    subtitle: "Turn inquiries into revenue",
    desc: "Automated booking, scheduling, and follow-up sequences close the gap between interest and booked jobs.",
    icon: "ri-bar-chart-grouped-line",
    color: "from-sapphire/15 to-transparent",
  },
];

const SolutionSection = () => {
  const { ref: headRef, visible: headVisible } = useScrollReveal();
  const { ref: colRef, visible: colVisible } = useScrollReveal();

  return (
    <section className="bg-white dark:bg-[#111] py-32 lg:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div
          ref={headRef}
          className={`reveal-el ${headVisible ? 'is-visible' : ''} text-center max-w-3xl mx-auto mb-20`}
        >
          <p className="text-sapphire text-xs font-bold uppercase tracking-widest mb-8">The Solution</p>
          <h2 className="text-5xl lg:text-6xl xl:text-7xl font-black text-[#1d1d1f] dark:text-white leading-[1.04] tracking-tight mb-6">
            We Build the System<br />That Fixes It
          </h2>
          <p className="text-[#6e6e73] dark:text-white/50 text-lg leading-relaxed">
            Blue Digital AI designs intelligent workflows that run your intake, booking, and follow-up—automatically.
          </p>
        </div>

        {/* Columns */}
        <div ref={colRef} className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {columns.map((col, i) => (
            <div
              key={col.title}
              className={`reveal-scale stagger-${i + 1} ${colVisible ? 'is-visible' : ''} relative bg-[#f5f5f7] dark:bg-white/[0.04] rounded-3xl p-10 overflow-hidden group hover:-translate-y-1 transition-transform duration-500`}
            >
              {/* Subtle gradient top */}
              <div className={`absolute top-0 left-0 right-0 h-48 bg-gradient-to-b ${col.color} pointer-events-none`}></div>

              <div className="relative z-10">
                <span className="text-xs font-black text-[#1d1d1f]/20 dark:text-white/15 tracking-widest">{col.number}</span>
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-sapphire/10 my-7">
                  <i className={`${col.icon} text-sapphire text-2xl`}></i>
                </div>
                <h3 className="text-4xl font-black text-[#1d1d1f] dark:text-white tracking-tight mb-2">{col.title}</h3>
                <p className="text-xs font-bold text-sapphire uppercase tracking-widest mb-5">{col.subtitle}</p>
                <p className="text-[#6e6e73] dark:text-white/40 leading-relaxed">{col.desc}</p>
              </div>

              {/* Hover bottom accent */}
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-sapphire to-deep-sapphire opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
